import { PageMeta } from "@/components/common/Seo/PageMeta"
import APIPage from "@/components/products/api/APIPage"
import { ProductSchema } from "@/components/products/ProductSchema"

const index = () => (
  <>
    <ProductSchema id="api" />
    <PageMeta
      meta={{
        title: "Crypto data API",
        description:
          "Access standardized onchain metrics, project data and financial statements for crypto through the Token Terminal API. Read the docs and get your API key.",
      }}
    />
    <APIPage />
  </>
)

export default index
